(function () {
  'use strict';
 
  var ITEM_SELECTOR = '.quick-cart__item[data-id]';
  var observerStarted = false;
 
  document.addEventListener('DOMContentLoaded', init);
 
  function init() {
    applyRules(); // in case the drawer's rows are already present
 
    if (!observerStarted) {
      var observer = new MutationObserver(function () {
        applyRules();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      observerStarted = true;
    }
  }
 
  function getRowMeta(row) {
    var orderGroup = null;
    var programFor = null;
 
    row.querySelectorAll('.quick-cart__item-properties').forEach(function (el) {
      var text = (el.textContent || '').trim();
      var idx = text.indexOf(':');
      if (idx === -1) return;
      var key = text.slice(0, idx).trim();
      var value = text.slice(idx + 1).trim();
      if (key === 'Order Group') orderGroup = value;
      if (key === 'Program For') programFor = value;
    });
 
    return { orderGroup: orderGroup, programFor: programFor };
  }
 
  function hasMainItem(rows, orderGroup) {
    return rows.some(function (row) {
      var meta = getRowMeta(row);
      return meta.orderGroup === orderGroup && !meta.programFor;
    });
  }
 
  function applyRules() {
    var rows = Array.prototype.slice.call(document.querySelectorAll(ITEM_SELECTOR));
    if (!rows.length) return;
 
    rows.forEach(function (row) {
      var meta = getRowMeta(row);
      var isAddon = meta.orderGroup && meta.programFor;
      var isMain = meta.orderGroup && !meta.programFor;
      var orphaned = isAddon && !hasMainItem(rows, meta.orderGroup);
 
      row.dataset.orderGroup = meta.orderGroup || '';
      row.dataset.programFor = meta.programFor || '';
 
      var removeBtn = row.querySelector('.quick-cart__button-remove');
      var decreaseBtn = row.querySelector('[data-decrease]');
      var increaseBtn = row.querySelector('[data-increase]');
 
      if (isAddon && !orphaned) {
        if (removeBtn && removeBtn.style.display !== 'none') {
          removeBtn.style.display = 'none';
        }
        if (decreaseBtn && decreaseBtn.style.display !== 'none') {
          decreaseBtn.style.display = 'none';
        }
        if (increaseBtn && increaseBtn.style.display !== 'none') {
          increaseBtn.style.display = 'none';
        }
      } else if (orphaned) {
        // Previously hidden by an earlier pass, then its main item
        // disappeared — restore normal controls.
        if (removeBtn) removeBtn.style.display = '';
        if (decreaseBtn) decreaseBtn.style.display = '';
        if (increaseBtn) increaseBtn.style.display = '';
      }
 
      if (isMain && removeBtn && !removeBtn.dataset.cascadeGuarded) {
        removeBtn.dataset.cascadeGuarded = 'true';
        removeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          cascadeRemove(row, meta.orderGroup);
        }, true);
      }
    });
  }
 
  function cascadeRemove(mainRow, orderGroup) {
    var rows = Array.prototype.slice.call(document.querySelectorAll(ITEM_SELECTOR));
    var updates = {};
 
    rows.forEach(function (row) {
      var meta = getRowMeta(row);
      if (row === mainRow || meta.orderGroup === orderGroup) {
        updates[row.dataset.id] = 0;
      }
    });
 
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
 
    fetch(rootUrl + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function (err) {
        console.error('quick-cart-order-groups: /cart/update.js failed', err);
        window.alert('Something went wrong updating your cart. Please refresh and try again.');
      });
  }
})();